//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react";
import { OrderbumpsContext } from "../context/OrderbumpsContext";
import { formatterDateDayMonth } from "../../../shared/utils";



//--------------- EXPORTAÇÃO DA PÁGINA ORDERBUMP RELATÓRIO ---------------//
export default function ContainerTableTransactions() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { transactions, setTransactions } = useContext(OrderbumpsContext); // Estado que armazena os Dados da busca feita pelo usuário



    //--------------- RETORNO CONDICIONAL DA PÁGINA ORDERBUMP RELATÓRIO ---------------//
    return (
        <>
            {!transactions.length
                ? null
                :
                <>
                    <div className="bg-surface-2 w-full gap-2 border border-white/[0.08] rounded-t-xl">
                        <h2 className="text-lg font-semibold text-brand-400 py-2 px-3 mb-2">Transações Principais</h2>
                    </div>
                    <div className="mb-6 bg-surface-2 rounded-b-xl scrollbar scrollbar-thumb-zinc-700 scrollbar-track-zinc-900 overflow-x-scroll shadow border border-white/[0.08]">
                        <table className="sm:w-full text-xs sm:text-sm table-auto">
                            <thead className="border-b border-white/[0.08]">
                                <tr className="text-left">
                                    <th className="py-2 px-3">Transação Principal</th>
                                    <th className="py-2 px-3">Cliente</th>
                                    <th className="py-2 px-3">Produto</th>
                                    <th className="py-2 px-3">Valor (R$)</th>
                                    <th className="py-2 px-3">Data Pedido</th>
                                    <th className="py-2 px-3">Data Aprovação</th>
                                </tr>
                            </thead>
                            <tbody>
                                {transactions.map((t, idx) => (
                                    <tr key={idx} className="border-b border-white/[0.06] text-left hover:bg-surface-3/30">
                                        <td className="py-2 px-3">{t.transacao}</td>
                                        <td className="py-2 px-3">{t.cliente}</td>
                                        <td className="py-2 px-3">{t.nome_produto}</td>
                                        <td className="py-2 px-3">R$ {Number(t.valor_produtor).toFixed(2)}</td>
                                        <td className="py-2 px-3">{formatterDateDayMonth(t.data_pedido)}</td>
                                        <td className="py-2 px-3">{formatterDateDayMonth(t.data_aprovacao)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            }
        </>
    );
}
